import React from 'react'
import ReactModal from 'react-modal'
import FormErrorBanner from 'Components/Element/FormErrorBanner';

function NoCaseFoundModal({uploadNew, onClose, errorMsg}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30
          
        },
        content: {
            height: 'auto',
            width: 'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
        <div className='flex items-center flex-col'>
            <FormErrorBanner>{errorMsg ? errorMsg : "No case found with this Case ID."}</FormErrorBanner>
                <div 
                className=" shadow-xl px-4 text-sm  w-max px-2 h-8 bg-green-600 hover:bg-green-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
                onClick={onClose}>Ok</div>
            </div>
    </ReactModal>
  )
}

export default NoCaseFoundModal;